namespace RedBullMOBILE360.CustomerCare {
    export namespace ManualResumeFraudCasesService {
        export const baseUrl = 'CustomerCare/ManualResumeFraudCases';

        export declare function Create(request: Serenity.SaveRequest<ManualResumeFraudCasesRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<ManualResumeFraudCasesRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<ManualResumeFraudCasesRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<ManualResumeFraudCasesRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function ExcelImport(request: Serenity.Extensions.ExcelImportRequest, onSuccess?: (response: Serenity.Extensions.ExcelImportResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function ManualResumeFraudCases(request: Serenity.ServiceRequest, onSuccess?: (response: ManualResumeResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "CustomerCare/ManualResumeFraudCases/Create",
            Update = "CustomerCare/ManualResumeFraudCases/Update",
            Delete = "CustomerCare/ManualResumeFraudCases/Delete",
            Retrieve = "CustomerCare/ManualResumeFraudCases/Retrieve",
            List = "CustomerCare/ManualResumeFraudCases/List",
            ExcelImport = "CustomerCare/ManualResumeFraudCases/ExcelImport",
            ManualResumeFraudCases = "CustomerCare/ManualResumeFraudCases/ManualResumeFraudCases"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List', 
            'ExcelImport', 
            'ManualResumeFraudCases'
        ].forEach(x => {
            (<any>ManualResumeFraudCasesService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
